import type { SelectBoxProps } from "../SelectBoxV2/SelectBoxV2";
import React from "react";
import { CreatableSelectBox } from "../CreateableSelectBox/CreatableSelectBox";

export function SearchSelect(props: SelectBoxProps) {
  return <CreatableSelectBox {...props} isSearchBar />;
}
